<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="box_2 flex-row">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG4724cd4fdb63b84c20b5fdc9c9238410.png')"
        />
        <span class="text_1">首页</span>
        <span class="text_2">解决方案</span>
        <span class="text_3">康复助手</span>
        <span class="text_4">产品介绍</span>
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc658033231306af285e327e654aace5d.png')"
        />
        <span class="text_5">功能及报价</span>
        <span class="text_6">关于我们</span>
        <div class="box_3 flex-row">
          <span class="text_7">登录</span>
          <div class="box_4 flex-col"></div>
        </div>
      </div>
      <span class="text_8">以动健康产品价格</span>
      <span class="text_9">专业、透明、可预约、可定制</span>
    </div>
    <div class="box_5 flex-col">
      <span class="text_10">免费试用，找到适合你的版本</span>
      <div class="box_6 flex-row justify-between">
        <div class="block_1 flex-col">
          <div class="group_1 flex-row">
            <div class="section_1 flex-col justify-between">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNGe51deb5d1e5df3abb6ac9bebfeba9499.png')"
              />
              <span class="text_11">个人版</span>
            </div>
            <div class="section_2 flex-col"></div>
            <div class="section_3 flex-col">
              <div class="block_2 flex-col"></div>
              <div class="block_3 flex-col"></div>
            </div>
            <div class="section_4 flex-col"></div>
          </div>
          <div class="text-wrapper_1 flex-col"><span class="text_12">免费试用</span></div>
          <div class="text-wrapper_2">
            <span class="text_13">适用于</span>
            <span class="text_14">个人康复治疗师、健身房私人康复工作室</span>
          </div>
          <div class="image-text_1 flex-row justify-between">
            <img
              class="thumbnail_2"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_1 flex-col justify-between">
              <span class="paragraph_1">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_15">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_16">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_2 flex-row justify-between">
            <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_2">200余种骨科康复特殊评估实验</span>
          </div>
          <div class="image-text_3 flex-row justify-between">
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_3">发送问卷功能</span>
          </div>
          <div class="image-text_4 flex-row justify-between">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_4">公共模板节省时间学习运动处方</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_5 flex-col justify-between">
              <span class="text_17">个人模板创建自己的运动康复模板</span>
              <span class="text_18">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_6 flex-row justify-between">
            <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_6">无限的病人数量</span>
          </div>
          <div class="image-text_7 flex-row justify-between">
            <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_7 flex-col justify-between">
              <span class="text_19">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_20">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_21">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_8 flex-row justify-between">
            <img
              class="thumbnail_9"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_8">每周7天的客服支持</span>
          </div>
          <div class="image-text_9 flex-row justify-between">
            <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_9">定制版Pad硬件设备</span>
          </div>
          <div class="image-text_10 flex-row justify-between">
            <img
              class="thumbnail_11"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_10 flex-col justify-between">
              <span class="paragraph_1">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_15">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_16">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_11 flex-row justify-between">
            <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_11 flex-col justify-between">
              <span class="paragraph_1">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_15">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_16">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_12 flex-row justify-between">
            <img
              class="thumbnail_13"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_12 flex-col justify-between">
              <span class="text_17">个人模板创建自己的运动康复模板</span>
              <span class="text_18">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_13 flex-row justify-between">
            <img
              class="thumbnail_14"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_13 flex-col justify-between">
              <span class="text_19">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_20">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_21">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_14 flex-row justify-between">
            <img
              class="thumbnail_15"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_14 flex-col justify-between">
              <span class="text_19">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_20">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_21">免费在线培训课程</span>
            </div>
          </div>
          <div class="text-wrapper_3">
            
            <span class="text_24">价格：</span>
            <span class="text_25">780</span>
            <span class="text_26">元/年</span>
          </div>
        </div>
        <div class="block_4 flex-col">
          <div class="group_2 flex-row">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG63f52c1108cb8b2235e279d948c40491.png')"
            />
            <div class="section_5 flex-col"></div>
            <div class="section_6 flex-col">
              <div class="group_3 flex-col"></div>
              <div class="group_4 flex-col"></div>
            </div>
          </div>
          <div class="text-wrapper_4 flex-col"><span class="text_27">免费试用</span></div>
          <div class="text-wrapper_5">
            <span class="text_28">适用于</span>
            <span class="text_29">大型社区、康复中心</span>
          </div>
          <div class="image-text_15 flex-row justify-between">
            <img
              class="thumbnail_16"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_15 flex-col justify-between">
              <span class="paragraph_4">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_30">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_31">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_16 flex-row justify-between">
            <img
              class="thumbnail_17"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_16">200余种骨科康复特殊评估实验</span>
          </div>
          <div class="image-text_17 flex-row justify-between">
            <img
              class="thumbnail_18"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_17">发送问卷功能</span>
          </div>
          <div class="image-text_18 flex-row justify-between">
            <img
              class="thumbnail_19"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_18">公共模板节省时间学习运动处方</span>
          </div>
          <div class="image-text_19 flex-row justify-between">
            <img
              class="thumbnail_20"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_19 flex-col justify-between">
              <span class="text_32">个人模板创建自己的运动康复模板</span>
              <span class="text_33">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_20 flex-row justify-between">
            <img
              class="thumbnail_21"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_20">无限的病人数量</span>
          </div>
          <div class="image-text_21 flex-row justify-between">
            <img
              class="thumbnail_22"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_21 flex-col justify-between">
              <span class="text_34">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_35">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_36">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_22 flex-row justify-between">
            <img
              class="thumbnail_23"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_22">每周7天的客服支持</span>
          </div>
          <div class="image-text_23 flex-row justify-between">
            <img
              class="thumbnail_24"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_23">定制版Pad硬件设备</span>
          </div>
          <div class="image-text_24 flex-row justify-between">
            <img
              class="thumbnail_25"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG0e25797670e2be06b34761bc7aacccdb.png')"
            />
            <span class="text-group_24">专属客服对接</span>
          </div>
          <div class="image-text_25 flex-row justify-between">
            <img
              class="thumbnail_26"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG0e25797670e2be06b34761bc7aacccdb.png')"
            />
            <span class="text-group_25">管理旗下医生的超级账户</span>
          </div>
          <div class="image-text_26 flex-row justify-between">
            <img
              class="thumbnail_27"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG0e25797670e2be06b34761bc7aacccdb.png')"
            />
            <span class="text-group_26">定制logo</span>
          </div>
          <div class="image-text_27 flex-row justify-between">
            <img
              class="thumbnail_28"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG0e25797670e2be06b34761bc7aacccdb.png')"
            />
            <span class="text-group_27">定制问卷内容（限制一份）</span>
          </div>
          <div class="image-text_28 flex-row justify-between">
            <img
              class="thumbnail_29"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_28 flex-col justify-between">
              <span class="paragraph_4">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_30">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_31">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_29 flex-row justify-between">
            <img
              class="thumbnail_30"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_29 flex-col justify-between">
              <span class="paragraph_4">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_30">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_31">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_30 flex-row justify-between">
            <img
              class="thumbnail_31"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_30 flex-col justify-between">
              <span class="text_32">个人模板创建自己的运动康复模板</span>
              <span class="text_33">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_31 flex-row justify-between">
            <img
              class="thumbnail_32"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_31 flex-col justify-between">
              <span class="text_34">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_35">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_36">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_32 flex-row justify-between">
            <img
              class="thumbnail_33"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_32 flex-col justify-between">
              <span class="text_34">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_35">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_36">免费在线培训课程</span>
            </div>
          </div>
          <div class="group_5 flex-col"></div>
          <span class="text_37">便携工作站</span>
          <div class="text-wrapper_6">
            <span class="text_38">合伙人价格：</span>
            <span class="text_39">18000</span>
            <span class="paragraph_5"><br /></span>
            <span class="paragraph_6">
              元/年
              <br />
            </span>
            <span class="text_40">市场指导价格：</span>
            <span class="text_41">90000</span>
            <span class="text_42"></span>
            <span class="text_43">元/年</span>
          </div>
        </div>
        <div class="block_5 flex-col">
          <div class="group_6 flex-row">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGdfba3eb552963407ba1d7d3e04e44f08.png')"
            />
            <div class="section_7 flex-col"></div>
            <div class="section_8 flex-col">
              <div class="group_7 flex-col"></div>
              <div class="group_8 flex-col"></div>
            </div>
          </div>
          <div class="text-wrapper_7 flex-col"><span class="text_44">免费试用</span></div>
          <div class="text-wrapper_8">
            <span class="text_45">适用于机构</span>
            <span class="paragraph_7">
              、健康管理机构、养
              <br />
              老产业
            </span>
          </div>
          <div class="image-text_33 flex-row justify-between">
            <img
              class="thumbnail_34"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_33 flex-col justify-between">
              <span class="paragraph_8">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_46">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_47">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_34 flex-row justify-between">
            <img
              class="thumbnail_35"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_34">200余种骨科康复特殊评估实验</span>
          </div>
          <div class="image-text_35 flex-row justify-between">
            <img
              class="thumbnail_36"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_35">发送问卷功能</span>
          </div>
          <div class="image-text_36 flex-row justify-between">
            <img
              class="thumbnail_37"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_36">公共模板节省时间学习运动处方</span>
          </div>
          <div class="image-text_37 flex-row justify-between">
            <img
              class="thumbnail_38"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_37 flex-col justify-between">
              <span class="text_48">个人模板创建自己的运动康复模板</span>
              <span class="text_49">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_38 flex-row justify-between">
            <img
              class="thumbnail_39"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_38">无限的病人数量</span>
          </div>
          <div class="image-text_39 flex-row justify-between">
            <img
              class="thumbnail_40"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_39 flex-col justify-between">
              <span class="text_50">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_51">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_52">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_40 flex-row justify-between">
            <img
              class="thumbnail_41"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <span class="text-group_40">每周7天的客服支持</span>
          </div>
          <div class="image-text_41 flex-row justify-between">
            <img
              class="thumbnail_42"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_41 flex-col justify-between">
              <span class="text_53">可以对接到常用的诊所，医院系统</span>
              <span class="text_54">专属客服对接</span>
            </div>
          </div>
          <div class="image-text_42 flex-row justify-between">
            <img
              class="thumbnail_43"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <span class="text-group_42">管理旗下医生的超级账户</span>
          </div>
          <div class="image-text_43 flex-row justify-between">
            <img
              class="thumbnail_44"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <span class="text-group_43">定制logo</span>
          </div>
          <div class="image-text_44 flex-row justify-between">
            <img
              class="thumbnail_45"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <span class="text-group_44">定制问卷内容（限制三份）</span>
          </div>
          <div class="image-text_45 flex-row justify-between">
            <img
              class="thumbnail_46"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <span class="text-group_45">定制运动处方计划（限制三份）</span>
          </div>
          <div class="image-text_46 flex-row justify-between">
            <img
              class="thumbnail_47"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_46 flex-col justify-between">
              <span class="text_55">自动发送问卷及运动处方给患者（可根据需要进行定制开发1套）</span>
              <span class="text_56">物联网硬件管理</span>
            </div>
          </div>
          <div class="image-text_47 flex-row justify-between">
            <img
              class="thumbnail_48"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_47 flex-col justify-between">
              <span class="text_57">定制版Pad硬件设备（可将设备更换为Pad版本）</span>
              <span class="text_58">
                软硬一体的可移动推车（工作站手推车一台。机构版使用年限：终身免费使用可建立50名免费医生账户）
              </span>
            </div>
          </div>
          <div class="image-text_48 flex-row justify-between">
            <img
              class="thumbnail_49"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_48 flex-col justify-between">
              <span class="paragraph_8">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_46">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_47">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_49 flex-row justify-between">
            <img
              class="thumbnail_50"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_49 flex-col justify-between">
              <span class="paragraph_8">
                3000+高清带解析的运动视频及分
                <br />
                解图
              </span>
              <span class="text_46">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
              <span class="text_47">70余种肌肉群组的运动方式</span>
            </div>
          </div>
          <div class="image-text_50 flex-row justify-between">
            <img
              class="thumbnail_51"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_50 flex-col justify-between">
              <span class="text_48">个人模板创建自己的运动康复模板</span>
              <span class="text_49">无限量的运动计划</span>
            </div>
          </div>
          <div class="image-text_51 flex-row justify-between">
            <img
              class="thumbnail_52"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_51 flex-col justify-between">
              <span class="text_50">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_51">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_52">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_52 flex-row justify-between">
            <img
              class="thumbnail_53"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG88d4772cdf701e3107a624696946a89b.png')"
            />
            <div class="text-group_52 flex-col justify-between">
              <span class="text_50">免费的患者端小程序应用：以动Rehab</span>
              <span class="text_51">显示机构/治疗师名字的视频及打印版处方</span>
              <span class="text_52">免费在线培训课程</span>
            </div>
          </div>
          <div class="image-text_53 flex-row justify-between">
            <img
              class="thumbnail_54"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_53 flex-col justify-between">
              <span class="text_53">可以对接到常用的诊所，医院系统</span>
              <span class="text_54">专属客服对接</span>
            </div>
          </div>
          <div class="image-text_54 flex-row justify-between">
            <img
              class="thumbnail_55"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_54 flex-col justify-between">
              <span class="text_55">自动发送问卷及运动处方给患者（可根据需要进行定制开发1套）</span>
              <span class="text_56">物联网硬件管理</span>
            </div>
          </div>
          <div class="image-text_55 flex-row justify-between">
            <img
              class="thumbnail_56"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9c553c76e4f383228fad4cfd99cd409d.png')"
            />
            <div class="text-group_55 flex-col justify-between">
              <span class="text_57">定制版Pad硬件设备（可将设备更换为Pad版本）</span>
              <span class="text_58">
                软硬一体的可移动推车（工作站手推车一台。机构版使用年限：终身免费使用可建立50名免费医生账户）
              </span>
            </div>
          </div>
          <div class="group_9 flex-col"></div>
          <span class="text_59">旗舰工作站</span>
          <div class="text-wrapper_9">
            <span class="text_60">合伙人价格：</span>
            <span class="text_61">98000</span>
            <span class="paragraph_9"><br /></span>
            <span class="paragraph_10">
              元/年
              <br />
            </span>
            <span class="text_62">市场指导价格：</span>
            <span class="text_63">360000</span>
            <span class="text_64"></span>
            <span class="text_65">元/年</span>
          </div>
        </div>
      </div>
      <div class="box_7 flex-row">
        <div class="box_8 flex-col"></div>
        <div class="box_9 flex-col"></div>
        <div class="box_10 flex-col"></div>
        <div class="box_11 flex-col"></div>
        <img
          class="thumbnail_57"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_58"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_59"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_66">合作医院</span>
      </div>
      <div class="box_12 flex-row">
        <div class="image-text_56 flex-col justify-between">
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGa1a9f53942284b3bdc02e9e69cb181e7.png')"
          />
          <span class="text-group_56">北京大学第一医院</span>
        </div>
        <div class="section_9 flex-col justify-between">
          <div class="box_13 flex-col">
            <div class="image-wrapper_1 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG59d351f29ca539417604e455bb4f7d21.png')"
              />
            </div>
          </div>
          <span class="paragraph_11">
            北京医院
            <br />
            （国家老年医学中心）
          </span>
        </div>
        <div class="image-text_57 flex-col justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGfc02edf2c2ddb79d91562cebeeb65698.png')"
          />
          <span class="text-group_57">北京大学人民医院</span>
        </div>
        <div class="image-text_58 flex-col justify-between">
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG54f9e3e5ad494c76b1e2601fb24819a6.png')"
          />
          <span class="text-group_58">
            首都医科大学附属
            <br />
            北京安定医院
          </span>
        </div>
        <div class="image-text_59 flex-col justify-between">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGf9256286f04e49c1617057ceb12b7ff6.png')"
          />
          <span class="text-group_59">
            首都医科大学
            <br />
            北京朝阳医院
          </span>
        </div>
        <div class="image-text_60 flex-col justify-between">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGf81d1249f53cdad108162a07979d4009.png')"
          />
          <span class="text-group_60">北京平安医院</span>
        </div>
        <div class="image-text_61 flex-col justify-between">
          <img
            class="image_11"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGcbf84e461ddf92f733231bd1fd49de3f.png')"
          />
          <span class="text-group_61">中日友好医院</span>
        </div>
        <div class="image-text_62 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGe3165c4926244ef8189e8a9c05b6fd5b.png')"
          />
          <span class="text-group_62">
            八里庄第二社区
            <br />
            卫生服务中心
          </span>
        </div>
      </div>
      <div class="box_14 flex-row">
        <div class="section_10 flex-col"></div>
        <div class="section_11 flex-col"></div>
        <div class="section_12 flex-col"></div>
        <div class="section_13 flex-col"></div>
        <img
          class="thumbnail_60"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_61"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_62"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_67">公司项目覆盖情况</span>
      </div>
      <div class="image-wrapper_2 flex-row">
        <img
          class="image_13"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png')"
        />
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG81b2d6d9eb5e06b85cd8af3f28f98fb9.png')"
        />
        <img
          class="image_15"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG5159410fc10ca594826b53eb6bbc51dc.png')"
        />
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGc0189645430acca8d357caeabdb4f886.png')"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGb19b3156911d708d7021a7e799ab7148.png')"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGe40066d95348fc239dd2466cc6f106e8.png')"
        />
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG251a106a920e59378ceee9ded7ea2c9d.png')"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png')"
        />
      </div>
      <div class="text-wrapper_10 flex-row">
        <span class="text_68">深圳招商健康</span>
        <span class="text_69">北京中日友好医院</span>
        <span class="text_70">北京老年医院</span>
        <span class="paragraph_12">
          北京大兴清源路街道
          <br />
          养老社区SMIC
        </span>
        <span class="text_71">北京聚陆医疗</span>
        <span class="paragraph_13">
          北京顺义“妙健康”金茂怡生园
          <br />
          加拿大健康管理中心
        </span>
      </div>
      <div class="text-wrapper_11 flex-col">
        <span class="text_72">联系方式</span>
        <span class="text_73">contact&nbsp;information</span>
        <span class="text_74">132-2019-0868</span>
        <span class="text_75">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        <span class="text_76">info&#64;ktangtang.com</span>
        <span class="text_77">https://ktangtang.com</span>
      </div>
      <div class="box_15 flex-col align-center"><div class="section_14 flex-col"></div></div>
      <div class="box_16 flex-col align-center"><div class="group_10 flex-col"></div></div>
      <div class="box_17 flex-col align-center"><div class="section_15 flex-col"></div></div>
    </div>
    <div class="box_18 flex-col">
      <div class="image-wrapper_3 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG33f935e7aff511ef96bc22348410d09b.png')"
        />
      </div>
      <div class="group_11 flex-row">
        <div class="block_6 flex-col justify-between">
          <div class="text-wrapper_12 flex-row justify-between">
            <span class="text_78">联系方式：13220190868</span>
            <span class="text_79">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_80">官网地址：https://ktangtang.com</span>
          <span class="text_81">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_13 flex-col justify-between">
          <span class="text_82">公众号：以动健康</span>
          <span class="text_83">官方微博：&#64;以动健康</span>
          <span class="text_84">京ICP备19026627号</span>
        </div>
        <div class="image-text_63 flex-col justify-between">
          <img
            class="image_22"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png')"
          />
          <span class="text-group_63">公众号二维码</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />